export default "__VITE_ASSET__a15b2adc__"